/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LanguageInputs */

const en_language = /** @type {(inputs: LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const id_language = /** @type {(inputs: LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa`)
};

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const es_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const fr_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const de_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const ja_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const zh_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const ar_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const it_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const ru_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const pt_language = en_language;

/** @type {(inputs: LanguageInputs) => LocalizedString} */
const ko_language = en_language;

/**
* | output |
* | --- |
* | "Language" |
*
* @param {LanguageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const language = /** @type {((inputs?: LanguageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LanguageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language(inputs)
	if (locale === "es") return es_language(inputs)
	if (locale === "fr") return fr_language(inputs)
	if (locale === "de") return de_language(inputs)
	if (locale === "ja") return ja_language(inputs)
	if (locale === "zh") return zh_language(inputs)
	if (locale === "ar") return ar_language(inputs)
	if (locale === "id") return id_language(inputs)
	if (locale === "it") return it_language(inputs)
	if (locale === "ru") return ru_language(inputs)
	if (locale === "pt") return pt_language(inputs)
	return ko_language(inputs)
});